import {
     PRODUCTS_QTY
} from '../../actions/types';

const INITIAL_STATE = {
    currentProductsQty: 0
};

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case PRODUCTS_QTY:
            return {
                ...state,
                currentProductsQty: action.payload
            }
        default:
            return state;
    }
}